module.exports = __webpack_public_path__ + "static/media/landingpageimg.6ace81d9.png";